<!--
 * @Author: baike
 * @LastEditors: baike 准入初筛
-->
<template>
  <div class="index">
    <div class="index_info">
      <Title class="head_label" title="准入初筛"></Title>

      <Info :projectInfo="projectInfo"></Info>

      <div class="btn_list">
        <el-button id="btn_next" @click="hanldeClick" type="primary"
          >执行初筛</el-button
        >
        <el-button id="btn_next" class="btn_back">返回</el-button>
      </div>
    </div>
    <DDialog title="提示" :show.sync="visibles" width="400px">
      <div>该项目准入否决，否决原因:{{ msg }}</div>
      <div slot="footer">
        <el-button size="small" @click="visibles = false">确 定</el-button>
      </div>
    </DDialog>
  </div>
</template>
<script>
import api from "@/api/index.js";
import Info from "../common/info.vue";
export default {
  props: {},
  components: { Info },
  data() {
    return {
      list: [
        {
          name_a: "项目编号",
          key_a: "projectCode",
          name_b: "项目名称",
          key_b: "projectName",
          name_c: "客户名称",
          key_c: "customerName",
        },
        {
          name_a: "产品名称",
          key_a: "productName",
          name_b: "担保金额(万元)",
          key_b: "guaranteeAmount",
          name_c: "担保期限(月)",
          key_c: "guaranteePeriod",
        },
        {
          name_a: "合作机构",
          key_a: "bankName",
          name_b: "经办人",
          key_b: "handlerName",
          name_c: "受理日期",
          key_c: "createTime",
        },
      ],
      projectInfo: {},
      info: {},
      visibles: false,
      msg: "",
    };
  },
  mounted() {
    this.getInfo();

    if (this.$route.query.projectCode) {
      localStorage.setItem("projectCode", this.$route.query.projectCode);
    }
  },
  methods: {
    hanldeClick() {
      let data = {
        customerId: this.info.customerInfo.customerId,
        customerName: this.info.projectInfo.customerName,
        userColumn: "client_id",
        scene: "10",
      };
      api.hanldePost("/api/ruleScence/checkAccessScene", data).then((res) => {
        if (res.status == 200) {
          this.$router.push({
            name: "access",
            query: { projectCode: this.$route.query.projectCode },
          });
        } else {
          this.msg = res.message;
          this.visibles = true;
        }
      });
    },
    getInfo() {
      let data = {
        projectCode:
          this.$route.query.projectCode || localStorage.getItem("projectCode"),
        // this.$route.query.projectCode
      };
      api.hanldePost("/api/business/front/viewApply", data).then((res) => {
        this.projectInfo = res.data.projectInfo;
        this.info = res.data;
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.index {
  .head_label {
    margin: 30px 0 30px 0;
  }

  .index_info {
    width: 1200px;
    margin: auto;
    background: white;
    padding: 10px 20px 40px 20px;
    margin-top: 30px;
  }
  .btn_list {
    display: flex;
    width: 100%;
    margin-top: 40px;
    justify-content: center;
    .btn_back {
      margin-left: 15px;
    }
  }
  .container {
    .con_box {
      margin-top: 40px;
      padding-left: 40px;
      .li_box {
        display: flex;
        .flex_1 {
          flex: 1;
          text-align: left;
          font-family: "Arial Normal", "Arial", sans-serif;
          font-weight: 400;
          font-style: normal;
          font-size: 14px;
          letter-spacing: normal;
          color: #333333;
          margin-bottom: 15px;
          display: flex;
          line-height: 20px;
          .name {
            width: 115px;
          }
          .value {
            width: 300px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
          }
        }
      }
    }
  }
}
</style>